<template>
	<v-app :id="nowWidth > 784 ? 'pageAdd' : 'm_pageAdd'">
		<router-view :class="nowWidth > 784 ? 'wide' : ''"></router-view>
		<v-dialog v-model="loading" fullscreen overlay-color="transparent" transition="dialog-center-transition" content-class="mainloadingBar">
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-progress-circular indeterminate :size="100" :width="5" color="grey lighten-1"> </v-progress-circular>
				</v-layout>
			</v-container>
		</v-dialog>
	</v-app>
</template>

<script>
export default {
	name: 'App',
	data() {
		return {
			loading: false,
			screenWidth: window.innerWidth,
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
				// if (/Android/i.test(navigator.userAgent) && this.nowWidth > 784) {
				// 	document.getElementsByTagName('body')[0].style.zoom = '20%'
				// } else {
				// 	document.getElementsByTagName('body')[0].style.zoom = '100%'
				// }
			})
			return this.screenWidth
		},
	},
	created() {
		// if (/Android/i.test(navigator.userAgent) && this.nowWidth > 784) {
		// 	document.getElementsByTagName('body')[0].style.zoom = '20%'
		// } else {
		// 	document.getElementsByTagName('body')[0].style.zoom = '100%'
		// }
	},
}
</script>
<style lang="scss">
@import './public/css/global.scss';
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;300;400;500;700;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;300;400;500;700;900&family=Noto+Serif+KR:wght@200;300;400;500;600;700;900&display=swap');
body {
	font-family: 'Noto Sans KR', sans-serif !important;
}
* {
	-webkit-text-size-adjust: none !important;
	-moz-text-size-adjust: none !important; /*Firefox*/
	-ms-text-size-adjust: none !important; /*Ie*/
	-o-text-size-adjust: none !important; /*old versions of Opera*/
	font-family: inherit !important;
}
#pageAdd {
	.v-application--wrap {
		overflow-y: auto !important;
		overflow-x: hidden !important;
	}
}
.wide {
	min-width: 784px !important;
}
#m_pageAdd {
	.v-application--wrap {
		overflow: auto !important;
		min-width: 320px !important;
	}
}
</style>
